import { apiClient } from '@/services/apiClient';
import type { SpotifyTrack } from '@/types';

type SpotifyTrackResponse = { tracks: SpotifyTrack[] };

export const getArtistTopTracks = async (artistId: string): Promise<SpotifyTrack[]> => {
  if (!artistId) return [];
  try {
    // Backend: GET /api/tracks/:artistId -> { tracks: [...] }
    const data = await apiClient.get<SpotifyTrackResponse>(`/api/tracks/${encodeURIComponent(artistId)}`);
    return Array.isArray(data?.tracks) ? data.tracks : [];
  } catch (e) {
    console.warn('Falha ao carregar top tracks. Configure SPOTIFY_CLIENT_ID/SECRET no server para habilitar.', e);
    return [];
  }
};
